import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useRef } from "react";
import '../../global.css';
import FormField from "../form/formField";
import ReCAPTCHA from "react-google-recaptcha";

const SignupForm = ({ number, setNumber, inviteCode, setInviteCode, handleSendOtp, setSignUp, submitting = false }) => {
    const { enqueueSnackbar } = useSnackbar();
    const recaptchaRef = useRef(null);

    const submitWithCaptcha = async () => {
        if (submitting) return;
        try {
            const token = await recaptchaRef.current?.executeAsync();
            recaptchaRef.current?.reset();
            handleSendOtp(token);
        } catch (error) {
            enqueueSnackbar("Captcha verification failed", { variant: "error" });
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && number?.length === 10 && !submitting) {
            submitWithCaptcha();
        }
    };

    return (
        <>
            <Stack spacing={1.5} mt={3}>
                <FormField label={"Enter Mobile No *"} inputProps={{
                    placeholder: "",
                    // type:"number",
                    value: number,
                    onChange: (e) => {
                        // console.log(RegExp('^[0-9]*$').test(e.target.value));
                        if (RegExp('^[0-9]*$').test(e.target.value) && e.target.value?.length < 11) {
                            setNumber(e.target.value)
                        }
                    },
                    onKeyPress: handleKeyPress,
                    InputProps: {
                        startAdornment: <InputAdornment position="start">
                            <Typography variant="body2" sx={{ color: "text.primary" }}>+91</Typography>
                        </InputAdornment>,
                        // endAdornment:<InputAdornment position="end">
                        //     <Button disabled={!(number?.length === 10)} variant="text">Send OTP</Button>
                        // </InputAdornment>
                    }
                }} />
            </Stack>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                size="invisible"
                badge="bottomright"
            />
            <Stack spacing={1.5} mt={2}>
                <FormField label={"Enter invite code *"} inputProps={{
                    placeholder: "",
                    // type:"number",
                    value: inviteCode,
                    onChange: (e) => {
                        setInviteCode(e.target.value)
                    },

                }} />
                <Stack direction={"row"} spacing={0.5}>
                    <Typography variant="body2">Already have an account?</Typography>
                    <Typography onClick={() => setSignUp(false)} variant="body2" sx={{ color: "primary.main", cursor: "pointer" }}>Login</Typography>
                </Stack>
            </Stack>
            <Button onClick={submitWithCaptcha} disabled={!(number?.length === 10 && inviteCode) || submitting} variant="contained" sx={{ mt: 4 }} fullWidth >{submitting ? "Sending..." : "Send OTP"}</Button>
        </>
    )
}

export default SignupForm